var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KIcon',{attrs:{"icon":"allActivities","color":"green"}})
}
var staticRenderFns = []

export { render, staticRenderFns }